import React from "react";
import classes from "./PriceList.module.css";
import Header from "../../components/Header/Header";
import FooterInfo from "../../components/FooterInfo/FooterInfo";
import { Helmet } from "react-helmet";
import { images } from "../../assets/img";
import BookNowBtn from "../../components/BookNowBtn";
import FloatingButton from "../../components/FloatingButton/FloatingButton";
import { SERVICE_PRICE_LIST } from "../../utils/PriceList";

const PriceList = () => {
  const servicePriceText = Object.entries(SERVICE_PRICE_LIST).map(
    ([group, { columns, items }]) => (
      <section key={group}>
        <h2>{group}</h2>
        <ul>
          {items.map(({ name, prices }) => (
            <li key={name}>
              {name}: {prices.map((price, index) => `${columns[index]} ${price}`).join(", ")}
            </li>
          ))}
        </ul>
      </section>
    )
  );

  return (
    <div className={classes.container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"Service List"}</title>
        <meta name="service-price-list" content="Service list" />
      </Helmet>
      <Header selected={"services"} />
      <div className={classes.wrapper}>
        <img
          src={images.pricing}
          alt={"Shine My Nails service price list"}
          decoding="async"
        />
        <div className={classes.screenReaderOnly} aria-label="Service prices">
          {servicePriceText}
        </div>

        <h1>Gift Voucher Available</h1>
        <BookNowBtn />
      </div>
      <FooterInfo style={classes.footerStyle} />
      <FloatingButton />
    </div>
  );
};

export default PriceList;
